import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Mineração",
    correct: false,
  },
  {
    option: "b) Siderurgia",
    correct: false,
  },
  {
    option: "c) Metalurgia",
    correct: false,
  },
  {
    option: "d) Automotiva",
    correct: true,
  },
  {
    option: "e) Todos são clientes em potencial",
    correct: false,
  },
];

export default function Question21(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question21: {
          title:
            "Quais desses segmentos não é um potencial cliente?",
          option: option.option,
          correct: option.correct,
          order: 21
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Quais desses segmentos não é um potencial cliente?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
